import axios from 'axios';
import {Dialog, Toast} from 'vant';
import router from "@/router";
import {encryptBase64, encryptWithAes, generateAesKey} from "@/lib/crypto.js";
import {encrypt} from "@/lib/jsencrypt.js";

let util = {}
const encryptHeader = 'encrypt-key';
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';
axios.defaults.headers.put['Content-Type'] = 'application/json; charset=UTF-8';

util.ajax = axios.create({
    timeout: 60000
})

util.ajax.interceptors.request.use(config => {

    const token = localStorage.getItem('access_token')
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token; // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['clientid'] = "041fd3cdf170f4104baf5a15621344cc";
    // 是否需要加密
    const isEncrypt = (config.headers || {}).isEncrypt === true;
    // 当开启参数加密
    if (isEncrypt && (config.method === 'post' || config.method === 'put')) {
        // 生成一个 AES 密钥
        const aesKey = generateAesKey();
        config.headers[encryptHeader] = encrypt(encryptBase64(aesKey));
        config.data = typeof config.data === 'object' ? encryptWithAes(JSON.stringify(config.data), aesKey) : encryptWithAes(config.data, aesKey);
    }
    return config
}, err => {
    return Promise.reject(err)
})


util.ajax.interceptors.response.use(
    res => {
        //需要解决登录成功但是必须修改密码问题
        if (res.data.code && res.data.code === 200001) {
            return res;
        }
        else if (res.data.code && res.data.code !== 200) {
            if(res.data.code===999){
                Dialog.alert({
                    title: '警告',
                    message: res.data.msg
                }).then(() => {
                    //修改密码的错误不要跳转
                    // if (router.currentRoute.name !== 'modifypass') {
                    //     router.replace("/login")
                    // }
                });
            }else if(res.data.code === 401){
                Dialog.alert({
                    title: '警告',
                    message: "登录状态，已失效，请重新登录"
                }).then(() => {
                    //修改密码的错误不要跳转
                    if (router.currentRoute.name !== 'modifypass') {
                        router.replace("/login")
                    }
                })
            }else if(res.data.code === 500){
                // 短信验证码返回不需要提示警告弹窗
                if(res.data.msg.indexOf('超过频率限制')!==-1){
                    Dialog.alert({
                        title: '警告',
                        message: res.data.msg
                    }).then(() => {
                        //修改密码的错误不要跳转
                        // if (router.currentRoute.name !== 'modifypass') {
                        //     router.replace("/login")
                        // }
                    });
                }else{
                    Dialog.alert({
                        title: '警告',
                        message: res.data.msg
                    }).then(() => {
                        //修改密码的错误不要跳转
                        if (router.currentRoute.name !== 'modifypass') {
                            router.replace("/login")
                        }
                    })
                }
            }else if(res.data.code === 503){
                Dialog.alert({
                    title: '警告',
                    message: res.data.msg
                }).then(() => {
                    //考勤状态未非打卡状态时，提示后，点击确定，刷新页面
                    window.location.reload()
                })
            }else if(res.data.code === 403){
                Dialog.alert({
                    title: '警告',
                    message: res.data.msg
                }).then(() => {
                    //修改密码的错误不要跳转
                    // if (router.currentRoute.name !== 'modifypass') {
                    //     router.replace("/login")
                    // }
                })
            }else if(res.data.code === -1){
                // 小助手功能，通知详情进来页面后，接口返回的code-1，提示信息后，重新回到小助手模块type不为1的时候，不会弹出提醒弹窗
                const url = window.location.href;
                let urlArr = url.split('&');
                let urlName = '';
                if(urlArr.length>0){
                    urlArr.map((v,k)=>{
                        if(v==='type=1'){
                            urlArr[k] = 'type=2';
                        }
                    });
                    urlName = urlArr.join('&');
                }
                Toast({
                    message: `${res.data.message?res.data.message:res.data.msg}`,
                    position: 'top',
                });
                if(urlName){
                    setTimeout(()=>{
                        window.location.href = urlName;
                    },900)
                }
            }
            return Promise.reject(res)
        }
        return res;
    },
    error => {
        if (error.response) {
            switch (error.response.code) {
                case 401:
                // window.location.href = url;
            }
            return Promise.reject(error);
        }
        Dialog.alert({
            title: '警告',
            message: error.message
        })
        return Promise.reject(error)
    }
);

util.getId = function () {
    let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    let nums = "";
    for (let i = 0; i < 32; i++) {
        let id = parseInt(Math.random() * 61);
        nums += chars[id];
    }
    return nums;
};
util.beijin = '/bj';
util.basepath = function () {
    return '/api/';
};
util.peopleUrl = function () {
    return '/api/dflow/form/cascade/user'
};
util.implementPersonUser = function () {
    return '/api/dflow/form/implementPerson/user'
};
util.formDateFormat = function (time) {
    let datetime = '-';
    if (time !== 0) {
        datetime = dateFormat(time);
    }
    return datetime;
};

function dateFormat(time) {
    let newTime = time.split('-');
    let a = '';
    for (let i = (newTime.length - 1); i >= 0; i--) {
        if (i === 0) {
            a = a + newTime[i];
            break;
        }
        a = a + newTime[i] + '-';
    }
    return a;
}

util.dateCheck = function (item) {
    return item.params.customDesign.type === 'date' || item.params.customDesign.type === 'datetime'
};
util.dateTimeFormatter = function (type, value) {
    if (type === 'year') {
        return `${value}年`;
    } else if (type === 'month') {
        return `${value}月`
    } else if (type === 'day') {
        return `${value}日`
    } else if (type === 'hour') {
        return `${value}点`
    } else if (type === 'minute') {
        return `${value}分`
    }
    return value;
};
util.dateFormatter = function (type, value) {
    if (type === 'year') {
        return `${value}年`;
    } else if (type === 'month') {
        return `${value}月`
    } else if (type === 'day') {
        return `${value}日`
    }
    return value;
};
util.timeFormatter = function (type, value) {
    if (type === 'hour') {
        return `${value}时`
    } else if (type === 'minute') {
        return `${value}分`
    }
    return value;
};
util.appleTimeFormat = function (time) {
    let date = '-';
    if (time) {
        date = time.split("T")[0];
    }
    return date;
};
util.time2YYYYMMDD = function (time) {
    let datetime = '';
    if (time !== 0) {
        let d = new Date(time);
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        if (month < 10) {
            month = `0${month}`;
        }
        let date = d.getDate();
        if (date < 10) {
            date = `0${date}`;
        }
        datetime = `${year}-${month}-${date}`;
    }
    return datetime;
};
util.timeStampStr2DateFormat = function (time) {
    let datetime = '';
    if (time !== 0) {
        let d = new Date(parseInt(time));
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        if (month < 10) {
            month = `0${month}`;
        }
        let date = d.getDate();
        if (date < 10) {
            date = `0${date}`;
        }
        let hour = d.getHours();
        if (hour < 10) {
            hour = `0${hour}`;
        }
        let minute = d.getMinutes();
        if (minute < 10) {
            minute = `0${minute}`;
        }
        datetime = `${year}-${month}-${date} ${hour}:${minute}`;
    }
    return datetime;
};
util.time2YMD = function (time) {
    let datetime = '';
    if (time !== 0) {
        let d = new Date(time.replace('+0000', 'Z'));
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        if (month < 10) {
            month = `0${month}`;
        }
        let date = d.getDate();
        if (date < 10) {
            date = `0${date}`;
        }
        datetime = `${year}-${month}-${date}`;
    }
    return datetime;
};
util.time2YMDHm = function (time) {
    let datetime = '';
    if (time !== 0 && time !== null ) {
        let d = new Date(time.replace('+0000', 'Z'));
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        if (month < 10) {
            month = `0${month}`;
        }
        let date = d.getDate();
        if (date < 10) {
            date = `0${date}`;
        }
        let hour = d.getHours();
        if (hour < 10) {
            hour = `0${hour}`;
        }
        let minute = d.getMinutes();
        if (minute < 10) {
            minute = `0${minute}`;
        }
        datetime = `${year}-${month}-${date} ${hour}:${minute}`;
    }
    return datetime;
};
util.time2DateStr = function (time) {
    let datetime = '';
    if (time !== 0) {
        let d = new Date(time);
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        if (month < 10) {
            month = `0${month}`;
        }
        let date = d.getDate();
        if (date < 10) {
            date = `0${date}`;
        }
        let hour = d.getHours();
        if (hour < 10) {
            hour = `0${hour}`;
        }
        let minute = d.getMinutes();
        if (minute < 10) {
            minute = `0${minute}`;
        }
        let second = d.getSeconds();
        if (second < 10) {
            second = `0${second}`;
        }
        datetime = `${year}-${month}-${date} ${hour}:${minute}:${second}`;
    }
    return datetime;
};
util.date2YYMMDDHHMISS = function (time) {
    let datetime = '';
    if (time !== 0) {
        let d = new Date(time);
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        if (month < 10) {
            month = `0${month}`;
        }
        let date = d.getDate();
        if (date < 10) {
            date = `0${date}`;
        }
        let hour = d.getHours();
        if (hour < 10) {
            hour = `0${hour}`;
        }
        let minute = d.getMinutes();
        if (minute < 10) {
            minute = `0${minute}`;
        }
        let second = d.getSeconds();
        if (second < 10) {
            second = `0${second}`;
        }
        datetime = `${year}-${month}-${date} ${hour}:${minute}:${second}`;
    }
    return datetime;
};
util.time2Hms = function (time) {
    let datetime = '';
    if (time !== 0) {
        let d = new Date(time.replace('+0000', 'Z'));
        let hour = d.getHours();
        if (hour < 10) {
            hour = `0${hour}`;
        }
        let minute = d.getMinutes();
        if (minute < 10) {
            minute = `0${minute}`;
        }
        let second = d.getSeconds();
        if (second < 10) {
            second = `0${second}`;
        }
        datetime = `${hour}:${minute}:${second}`;
    }
    return datetime;
};
util.showBaseNo = function (item) {
    let baseNo = '-';
    if (item.variables) {
        if (item.variables.BaseNo) {
            baseNo = item.variables.BaseNo;
        }
    }
    return baseNo;
};
util.showBaseName = function (item) {
    let baseNo = '-';
    if (item.variables) {
        if (item.variables.baseName) {
            baseNo = item.variables.baseName;
        }
    }
    return baseNo;
};

util.peopleShow = function (data) {
    let item = '';
    for (let i = 0; i < data.length; i++) {
        if (i === (data.length - 1)) {
            item += data[i];
            break;
        }
        item += data[i] + ',';
    }

    return item === '' ? '-' : item;
};
util.relateDataShow = function (data) {

    let dataArray = [];
    let item = '';
    if (data !== null && data.trim() !== '') {

        data = data.trim()
        if (data.slice(-1) === ']') {
            data = data.slice(0, -1).trim()
        }


        let baseNos = data.split(',');
        for (let i = 0; i < baseNos.length; i++) {
            dataArray = baseNos[i].split('_');
            if (i === baseNos.length - 1) {
                item += dataArray[1];
                break;
            }
            item += dataArray[1] + ',';
        }
    }
    if (item === '') {
        item = '-';
    }
    return item
};
export default util;